import React from 'react';

import MappingAttributeAdministration from "../attribute/components/MappingAttributeAdministration";
import MappingValueList from "../attribute/components/MappingValueList";
import SizeConversionTable from "../attribute/components/SizeConversionTable";

import ProductMappingStats from "components/ProductMappingStats";
import CustomButton from "components/CustomButton";

function MappingPage(props) {
    return (
        <div style={{
            marginLeft: '240px',
            display: 'flex',
            flexDirection: 'column',
            padding: '24px',
        }}>
            <ProductMappingStats retailerId={props.retailer?.id} />
            <div style={{
                marginTop: '24px',
                display: 'flex',
                gap: '32px',
            }}>
                <div style={{flex: 1}}>
                    <h3 style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#111827',
                        marginBottom: '16px',
                    }}>
                        Administration
                    </h3>
                    <MappingAttributeAdministration />

                    <h3 style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#111827',
                        marginTop: '32px',
                        marginBottom: '16px',
                    }}>
                        Conversions de tailles
                    </h3>
                    <SizeConversionTable />
                </div>

                <div style={{flex: 1}}>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '16px',
                    }}>
                        <h3 style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#111827',
                            margin: 0,
                        }}>
                            Mapping
                        </h3>
                        <CustomButton>
                            Valider en masse
                        </CustomButton>
                    </div>
                    <MappingValueList />
                </div>
            </div>
        </div>
    );
}

export default MappingPage;
